import React from 'react';
import { MarketingArticle } from './marketingArticle.jsx';
import heroImage from '../pictures/PCI_express_front.avif';
import productImage from '../pictures/BSB100.webp';
import sampleImage from '../pictures/Sample.avif';

export function BSB_B010() {
  return (
    <MarketingArticle
      title="BSB-G010 Server Generator"
      kicker="Dedicated hardware"
      description="A plug-in generator board for partners who want to build their own Back-Step Blockchain server applications."
      path="/products"
      heroImage={heroImage}
      heroAlt="BSB-G010 PCI Express board"
      primaryAction={{ to: '/contact', label: 'Request product discussion' }}
      secondaryAction={{ to: '/products', label: 'Back to products' }}
      sections={[
        {
          tag: 'Best fit',
          title: 'For teams building a dedicated blockchain service.',
          image: productImage,
          imageAlt: 'BSB hardware module',
          paragraphs: [
            'The BSB-G010 is intended for application builders, integrators, and enterprises that want to operate a dedicated Back-Step Blockchain server.',
            'It gives partners a hardware foundation for product certificates, trusted logs, business records, and other proof-heavy applications.',
          ],
          items: [
            'Server-based deployment with driver and API support.',
            'Designed for secure generation and long-term operation.',
            'Suitable for pilots that need a path to production hardware.',
          ],
        },
        {
          tag: 'Support',
          title: 'We help partners connect the hardware to the business workflow.',
          image: sampleImage,
          imageAlt: 'Sample blockchain product concept',
          paragraphs: [
            'The product roadmap includes middleware, sample drivers, status reporting, and verification tools so teams can focus on the application and customer experience.',
            'Technical specifications can be shared during partner discussions when a concrete deployment target is known.',
          ],
        },
      ]}
    />
  );
}
